import type { FunctionComponent, PropsWithChildren } from 'react'
import styled from 'styled-components'
import AccordionBlock from '../Accordion/AccordionBlock'
import useBreakpoint, { Breakpoint } from '../../hooks/useBreakpoint'

const StyledAccordionBlock = styled(AccordionBlock)`
  margin-bottom: 0.75rem;
`

interface FooterSectionProps {
  title: string
}
const FooterSection: FunctionComponent<PropsWithChildren<FooterSectionProps>> = ({
  children,
  title,
}) => {
  const showDesktopVariant = useBreakpoint({ minBreakpoint: Breakpoint.Md })

  return (
    <StyledAccordionBlock isFooter title={title} id={title} isExpandable={!showDesktopVariant}>
      {children}
    </StyledAccordionBlock>
  )
}

export default FooterSection
